import { createReducer } from 'redux-act';

import { feedbackReceived, sendFeedback } from '../actions/feedback/sendFeedback';

export interface FeedbackState {
  message: string;
}

const defaultState: FeedbackState = { message: '' };

const feedbackReducer = createReducer<FeedbackState>({}, defaultState);

feedbackReducer.on(feedbackReceived, (_) => ({ message: '' }));

feedbackReducer.on(sendFeedback, (_, { feedback }) => ({ message: feedback.message }));

export default feedbackReducer;
